import {
  VERIFICADNI_SUCCESS,
  VERIFICADNI_LOADING,
  VERIFICADNI_ERROR,
} from "../../ActionTypes";

import axiosInstance from "../../../../global/helpers/axiosInstance";
import axiosLogin from "global/helpers/axiosLogin";

export const verificaDni = (txtVerificaDni, nextStep) => (dispatch) => {
  dispatch({
    type: VERIFICADNI_LOADING,
  });

  axiosLogin().then((respuesta) => {
    respuesta
      .get("/shared/registro/verificar/" + txtVerificaDni)
      .then((res) => {
        dispatch({
          type: VERIFICADNI_SUCCESS,
          payload: res.data,
        });
        if (nextStep) nextStep(true, res.data);
      })

      .catch((err) => {
        let error = {
          status: err.response?.status,
          data: err.response?.data,
        };
        dispatch({
          type: VERIFICADNI_ERROR,
          payload: error,
        });
        if (nextStep) nextStep(false, error);
      });
  });
};
// export const verificaDni = (txtVerificaDni) => (dispatch) => {
//   dispatch({
//     type: VERIFICADNI_LOADING,
//   });
//   axiosInstance().then(respuesta => {
//   respuesta
//   .get("/registro/verificar/" + txtVerificaDni)
//   .then((res) => {
//     dispatch({
//       type: VERIFICADNI_SUCCESS,
//       payload: res.data,
//     });
//   })

//   .catch((err) => {
//     let error = {
//         status: err.response.status,
//         data: err.response.data
//     };
//     dispatch({
//       type: VERIFICADNI_ERROR,
//       payload: error,
//     });
//   });
//  } )
// };
